'use client';

import {
    Alert,
    Align,
    Button,
    ButtonList,
    ButtonVariant,
    Image,
    Modal,
    ModalBody,
    ModalFooter,
    StatusState,
    Text,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { RepeaterProduct } from '@app-types/product';

import { InlinePrice } from '@components/inline-price';

import { MEDIA_BASE_URL } from '@helpers/config';

import { Sticker } from '@trilogy-ds/react';

interface BboxOtisOptionModalProps {
    onClose: () => void;
    active: boolean;
    onAddOtisRepeater: () => void;
    isRepeaterAdded: boolean;
    shouldShowAlert: boolean;
    repeater: RepeaterProduct;
}

export default function BboxOtisOptionModal({
    onClose,
    active,
    onAddOtisRepeater,
    isRepeaterAdded,
    shouldShowAlert,
    repeater,
}: Readonly<BboxOtisOptionModalProps>) {
    return (
        <Modal active={active} onClose={onClose} title={repeater.name ?? 'Répéteur WiFi'}>
            <ModalBody>
                {repeater.promoLabel && <Sticker variant={TrilogyColor.ACCENT} small label={repeater.promoLabel} />}
                <br />
                {repeater.longDescription ?? (
                    <Text>
                        Vous habitez un logement de plus de 80 m²&nbsp;? Il y a un étage chez vous&nbsp;? Disponible en
                        option avec la B&YOU Pure fibre, le répéteur WiFi vous garantit une couverture WiFi
                        idéale&nbsp;!
                    </Text>
                )}
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    +<InlinePrice amount={repeater.prices.final} period='mois' />
                </Text>

                <View className='has-text-centered img-modal'>
                    <Image
                        src={repeater.imgRepeater?.public_url || `${MEDIA_BASE_URL}/Repeteur.webp`}
                        alt='Box'
                        width={160}
                        height={200}
                        align={Align.CENTER}
                    />
                </View>
                <Alert
                    status={StatusState.WARNING}
                    display={shouldShowAlert}
                    title="Ajoutez d'abord l'offre Pure Fibre"
                    description="L'option répéteur WiFi est seulement compatible avec une offre Pure Fibre. Ajoutez-en une pour continuer !"
                />
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.SECONDARY} onClick={onClose}>
                        Fermer
                    </Button>
                    <Button
                        variant={isRepeaterAdded ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
                        onClick={onAddOtisRepeater}
                    >
                        {isRepeaterAdded ? 'Retirer du panier' : 'Ajouter au panier'}
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
